import profileStyles from "../../styles/userProfile.module.css";
import { BagstageUserDetails } from "../../types/user.types";

export default function ProfileChip({
  bagstageUser
}: {
  bagstageUser: BagstageUserDetails;
}) {
  return (
    <div className={profileStyles.userProfileChip}>
      {bagstageUser.userInitials}
    </div>
  );
}
